module.exports = __webpack_public_path__ + "static/media/10.048eefc8.png";